import { z } from 'zod';
import { buyerPhoneSchema } from '../_shared/phone.js';
const passengersCountSchema = z.object({
    adults: z.number().optional(),
    babies: z.number().optional(),
    infants: z.number().optional(),
    seniors: z.number().optional(),
    youngsters: z.number().optional(),
});
export const createSessionSchema = z.object({
    accountCode: z.string().optional(),
    departureDate: z.string().min(1),
    destination: z.string().min(1),
    journeyKeys: z.array(z.string().min(1)),
    offerKey: z.string().min(1),
    origin: z.string().min(1),
    passengersCount: passengersCountSchema,
    returnDate: z.string().optional(),
    transactionKey: z.string().min(1),
    tripType: z.string().min(1),
    // Vrai quand la sélection vient de /vols-multi/resultats (page ouverte par Helix).
    viaChatbot: z.boolean().default(false),
});
export const applyPromoCodeSchema = z.object({
    code: z.string().min(1),
});
export const submitDepositReservationSchema = z.object({
    buyerEmail: z.string().optional(),
    buyerPhone: buyerPhoneSchema.optional(),
    subscribeToNotifications: z.boolean().optional(),
});
export const submitInsuranceSchema = z.object({
    withInsurance: z.boolean(),
});
